<template>
  <v-app>
    <Topmenubar />

    <v-main>
      <v-card>
        <v-container class="px-0">
          <div class="container-small">
            <v-list-item>
              <v-btn
                class="mr-3"
                icon
                large
                color="primary"
                dark
                append
                to="/profiles/1"
              >
                <v-icon color="primary">mdi-arrow-left</v-icon>
              </v-btn>
              <v-list-item-title class="display-1 ma-0"
                >Functietitel</v-list-item-title
              >
            </v-list-item>
          </div>
        </v-container>
        <v-divider></v-divider>
      </v-card>
      <v-container>
        <div class="container-small py-15">
          <p>
            Wijzigingen in je functietitel worden overal in je Kyano account
            weergeven.
          </p>
          <v-row>
            <v-col cols="12" md="7">
              <v-card
                elevation="0"
                outlined
                class="border rounded-lg mb-5 pa-5"
              >
                <v-html class="overline">Functietitel wijzigen</v-html>
                <v-spacer class="py-4"></v-spacer>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="profiles.funtiontitle"
                      label="Functietitel"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="ml-auto text-right">
                    <v-btn
                      color="default"
                      right
                      to="/companies"
                      class="mr-3"
                      elevation="0"
                    >
                      Annuleren
                    </v-btn>
                    <v-btn
                      color="secondary"
                      right
                      @click="submit"
                      elevation="0"
                    >
                      Opslaan
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col offset-md="1" cols="12" md="4">
              <DataPrivacy />
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Topmenubar from "../../components/Topmenubar.vue";
import DataPrivacy from "../../components/DataPrivacy.vue";

export default {
  components: {
    Topmenubar,
    DataPrivacy,
  },

  props: {
    profiles: Object,
  },
  data: () => ({}),
};
</script>
